import Vue from 'vue'
import Vuex from 'vuex'
import billStore from './modules/bill';
import inOutReport from './modules/inoutreport.js';
import customerSupport from './modules/customerSupport';
import arLang from './arLang.js'
import enLang from './enLang.js'
import urLang from './urLang.js'

type LicenseTypeState = Record<string, unknown> & {
  activemenu?: string;
  logo?: string;
};

type RootState = Record<string, unknown> & {
  licenseType: LicenseTypeState;
  permissionMode?: string;
  userPermissions?: string[];
  deniedPermissions?: string[];
  roleKeys?: string[];
};

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logo: 'ecar-logo.png',
    yesNoList_ar: [
      {text: 'نعم', value: 1},
      {text: 'لا', value: 0},
    ],
    sidebarSize: {
      small: "700px",
      med: "800px",
      large: "90%",
      half: "50%",
      three_q: "75%"
    },
    yesNoList_en: [
      {text: 'Yes', value: 1},
      {text: 'No', value: 0},
    ],
    daysList: [
      {text: '1', value: '1'},
      {text: '2', value: '2'},
      {text: '3', value: '3'},
      {text: '4', value: '4'},
      {text: '5', value: '5'},
      {text: '6', value: '6'},
      {text: '7', value: '7'},
      {text: '8', value: '8'},
      {text: '9', value: '9'},
      {text: '10', value: '10'},
      {text: '11', value: '11'},
      {text: '12', value: '12'},
      {text: '13', value: '13'},
      {text: '14', value: '14'},
      {text: '15', value: '15'},
      {text: '16', value: '16'},
      {text: '17', value: '17'},
      {text: '18', value: '18'},
      {text: '19', value: '19'},
      {text: '20', value: '20'},
      {text: '21', value: '21'},
      {text: '22', value: '22'},
      {text: '23', value: '23'},
      {text: '24', value: '24'},
      {text: '25', value: '25'},
      {text: '26', value: '26'},
      {text: '27', value: '27'},
      {text: '28', value: '28'},
      {text: '29', value: '29'},
      {text: '30', value: '30'},
      {text: '31', value: '31'},
    ],
    monthsList: [
      {text: '1', value: '1'},
      {text: '2', value: '2'},
      {text: '3', value: '3'},
      {text: '4', value: '4'},
      {text: '5', value: '5'},
      {text: '6', value: '6'},
      {text: '7', value: '7'},
      {text: '8', value: '8'},
      {text: '9', value: '9'},
      {text: '10', value: '10'},
      {text: '11', value: '11'},
      {text: '12', value: '12'}
    ],
    yearList: [
      {text: '2021', value: '2021'},
      {text: '2022', value: '2022'},
      {text: '2023', value: '2023'},
      {text: '2024', value: '2024'},
      {text: '2025', value: '2025'},
      {text: '2026', value: '2026'},
    ],
    plateChars: [
        {text: '', value: ''},
        {text: 'أ - A', value: 'ا'},
        {text: 'ب - B', value: 'ب'},
        {text: 'ح - J', value: 'ح'},
        {text: 'د - D', value: 'د'},
        {text: 'ر - R', value: 'ر'},
        {text: 'س - S', value: 'س'},
        {text: 'ص - X', value: 'ص'},
        {text: 'ط - T', value: 'ط'},
        {text: 'ع - E', value: 'ع'},
        {text: 'ق - G', value: 'ق'},
        {text: 'ك - K', value: 'ك'},
        {text: 'ل - L', value: 'ل'},
        {text: 'م - Z', value: 'م'},
        {text: 'ن - N', value: 'ن'},
        {text: 'ه - H', value: 'ه'},
        {text: 'و - U', value: 'و'},
        {text: 'ى - V', value: 'ى'},
    ],
    showLoading: false,
    showFirst: true,
    showMessage: true,
    customers: [],
    COOKIEPhase: 'SAMCCCC-Cookies',
    LangCooki: 'SAMCLANG-Cookies',
    SAMCOTEC: {
      r_path: '/api/index.php',
      p_path: '/api/export-print.php',
      e_path: '../api/excel.php',
      pd_path: '../api/pdf.php',
    },
    settings: {
      dev_vat: 15,
    },
    currentMenu: "CurrentMenu",
    vcurrentMenu: "VCurrentMenu",
    currentlink: "currentlink",
    userinfo: [],
    lang:{
      en: enLang,
      ar: arLang,
      ur: urLang,
    },
    activemenu: 'bill',
    loginRedirect: '',
    caneditinvoicedate: true,
    connected: false,
    products: [],
    smsTemp:[],
    hometitle: 'الفواتير',
    hometitle_en: 'Invoices',
    carsys: false,
    debug:0,
    licenseType: {
      manafactoring_enable: false,
      show_jobcard: false,
      sam_project: false,
      car_contract: false,
      samcrm: false,
      showIDNumber: false,
      erp: false,
      showOwnerName: false,
      showCarPlate: false,
      perDiscount: false,
      showPlate: false,
      requirePurchase: false,
      showSketch: false,
      showCardNums: false,
      startYear: 2021,
      activemenu: '',
      otherproducts: false,
      cars: false,
      carInfoRequired: false,
      parts: false,
      bill: false,
      quotation: false,
      clientStatment:false,
      carinfo: false,
      salarysys: false,
      showproject: false,
      crm: false,
      showAddedBy: false,
      printDelNotes: false,
      agentPurchase: false,
      expenses: false,
      POSREST: false,
      POSRET: false,
      families: false,
      fullversion:false,
      orderlic: false,
      onlySalesPurchase: true,
      isBill: false,
      isSupport: false,
      isCar: false,
      showInvoiceList: false,
      showMaintCart:false,
      showItemCode: false,
      require_itemcode: false,
      moneyComma: false,
      showExtra: false,
      demoVersion: false,
    },
    viewhomeaddinvo:false,
    zeroPrice:true,
    SystemName: 'SAMCOTEC',
    Version: "ERP - 3.6.00",
    deflang: 'ar',

    group_id: 0,
    permissionMode: 'loading',
    userPermissions: [],
    deniedPermissions: [],
    roleKeys: [],

    headerIcone: 1
  },
  getters:{
    state: function(state: RootState): RootState { return state }
  },
  mutations: {
    setLicenseType: function(state: RootState, val: LicenseTypeState): void {
      Object.keys(val).forEach(key => {
        if(key != 'activemenu'  && key != 'logo'){
          state.licenseType[key] = true;
        }
        else state.licenseType[key] = val[key];
      });
    },
    setEffectivePermissions: function(state: RootState, val: Record<string, unknown> = {}): void {
      const stateUserInfo = state.userinfo && typeof state.userinfo === 'object'
        ? state.userinfo as Record<string, unknown>
        : {};
      const fallbackGroupId = String(
        val.group_id
        || val.groupId
        || stateUserInfo.group_id
        || stateUserInfo.groupId
        || state.group_id
        || ''
      );
      const fallbackUsername = String(
        val.username
        || stateUserInfo.username
        || ''
      ).trim().toLowerCase();
      const hasPermissionPayload = Boolean(
        val
        && (
          val.mode
          || typeof val.legacy_mode !== 'undefined'
          || Array.isArray(val.permissions)
          || Array.isArray(val.denied_permissions)
          || Array.isArray(val.role_keys)
        )
      );

      if (!hasPermissionPayload && (fallbackGroupId === '1' || fallbackUsername === 'admin' || fallbackUsername === 'master')) {
        state.permissionMode = 'admin';
        state.userPermissions = ['*'];
        state.deniedPermissions = [];
        state.roleKeys = [];
        return;
      }

      if (!hasPermissionPayload && state.permissionMode && state.permissionMode !== 'loading') {
        return;
      }

      const permissions = Array.isArray(val.permissions) ? val.permissions as string[] : [];
      const deniedPermissions = Array.isArray(val.denied_permissions) ? val.denied_permissions as string[] : [];
      const roleKeys = Array.isArray(val.role_keys) ? val.role_keys as string[] : [];
      const hasPermissionMode = Boolean(val && (val.mode || typeof val.legacy_mode !== 'undefined'));
      state.permissionMode = hasPermissionMode ? String(val.mode || (val.legacy_mode ? 'legacy' : 'strict')) : (hasPermissionPayload ? 'strict' : 'loading');
      state.userPermissions = permissions;
      state.deniedPermissions = deniedPermissions;
      state.roleKeys = roleKeys;
    },
  },
  actions: {

  },
  modules: {
    billStore,
    inOutReport,
    customerSupport
  }
})
